import {Component, OnInit} from '@angular/core';
import {SiteReferenceService} from "../site-reference.service";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  totalDistance = this.siteReferenceService.missionsSummary.total_distance;
  averageDistance = this.totalDistance / this.siteReferenceService.missionsSummary.count;
  link = '/gliders/deployments';
  introText =
    `The world's oceans are vast and cannot be properly described using research vessels only. Satellite
            technology has greatly improved our ability to obtain global coverage of some environmental
            variables, but satellites cannot see into the ocean's interior. Autonomous gliders can help to fill
            the gaps between shipboard sampling and satellite imagery.`;
  mapSubtext = `This map displays all currently deployed gliders. Click to learn more about an individual ` +
    `deployment. To see past deployments, refer to <a href="` + this.link + `">Deployments</a>.`;
  currentDeploymentNumbers = null;
  filterOptions = {deployments: 'All'};
  groups = eval(this.siteReferenceService.activeDeployments)['glider_groups'];
  ids = this.groups.map(group => group.deployment_number);
  hasCurrent = this.ids.length > 0;

  constructor(private siteReferenceService: SiteReferenceService) {
  }

  ngOnInit() {
    const groups = this.groups;
    if (this.hasCurrent) {
      this.currentDeploymentNumbers = this.ids;
      this.filterOptions = {
        deployments: 'Current'
      };
    }
  }

}
